/*
 * @Description: 结算单管理
 * @Author: 杨志航
 * @Date: 2026-05-14 09:41:31
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import SettlementMethod from './SettlementMethod'
import './assets/style.scss'

const Index = ({ match, history }) => {
  return (
    <div>
      <Switch>
        <Route path={match.path + '/settlementMethod'} component={SettlementMethod} />
        <Route component={SettlementMethod} />
      </Switch>
    </div>
  )
}

export default Index